import React from "react";
import Space from "../../commons/Space";
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./DanzaInfoCorsi.css"

function DanzaInfoCorsi() {
    return(
        <div className="info-corsi" style={{width: "80%", margin: "auto"}}>
            <dl className="row align-content-center" >
                <dt className="col-sm-3">Propedeutica</dt>
                <dd className="col-sm-9 mb-4">
                    Attraverso il gioco, la musica e l’espressione corporea, il corso introduce i bambini ai primi principi di coordinazione, musicalità, equilibrio e capacità motorie di base. L’insegnante, altamente qualificata, accompagna ogni allievo nel suo sviluppo psicofisico con competenza, attenzione e rispetto dei tempi di apprendimento.
                </dd>


                <dt className="col-sm-3">Modern Contemporaneo</dt>
                <dd className="col-sm-9 mb-4">
                    Il corso approfondisce la tecnica modern e contemporanea, sviluppando controllo, forza, fluidità e consapevolezza del movimento. Le lezioni sono guidate da un’insegnante con formazione accademica e professionale, offrendo un percorso adatto alle esigenze di ogni allievo.
                </dd>

                <dt className="col-sm-3">Acro</dt>
                <dd className="col-sm-9 mb-4">
                    Corso dedicato agli elementi di acrobatica applicati alla danza contemporanea, per ampliare le possibilità espressive del corpo e acquisire maggiore sicurezza nei movimenti. Le attività sono proposte nel rispetto dell’età e dei tempi di apprendimento di ogni allievo, con un insegnante qualificato e professionista del settore.
                </dd>

                <dt className="col-sm-3">Hip Hop</dt>
                <dd className="col-sm-9 mb-4">
                    Lezioni dedicate agli elementi tecnici fondamentali dell’Hip Hop e dei suoi principali sottostili, unendo tecnica, musicalità e divertimento. Il corso è tenuto da un’insegnante qualificata e professionista del settore.
                </dd>

                <dt className="col-sm-3">Partnering</dt>
                <dd className="col-sm-9 mb-4">
                    Partnering è una pratica basata sulla fiducia e collaborazione tra due persone attraverso il movimento.
                    Il corso sviluppa consapevolezza, sensibilità, coordinazione e capacità di improvvisazione offrendo strumenti tecnici e creativi per danzare insieme in modo sicuro ed espressivo superando ogni paura ed ostacolo nel sollevare e nell’essere sollevato.
                </dd>

            </dl>
        </div>
    )
}

export default DanzaInfoCorsi